let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9ey7F")).then(() => parcelRequire('4A6Bi'));